import type { DeviceNotificationPort } from '@Domain/Ports/Notification/DeviceNotificationPort';

type Args = {
	/** Screen route of the subject, built by the caller: `Application/` never knows UI routes. */
	readonly subjectPath: string;
	readonly localInterviewId: string;
};

/**
 * Tells the user, through the device, that an interview was deleted while its recording was still
 * being sent. Never asks for the permission: without it, nothing is shown (the banner remains).
 */
const notifyOrphanedInterview = async (
	notificationPort: DeviceNotificationPort,
	{ subjectPath, localInterviewId }: Args,
): Promise<void> => {
	if (notificationPort.permission() !== 'granted') {
		return;
	}

	await notificationPort.show({
		title: 'Attention, cet enregistrement a été supprimé du dossier.',
		body: 'Vous avez encore ses données sur cet appareil. Ouvrez Dixit pour choisir ce que vous voulez en faire.',
		tag: `orphaned-interview-${localInterviewId}`,
		targetPath: `${subjectPath}/local-interviews/${localInterviewId}/upload`,
	});
};

export default notifyOrphanedInterview;
